import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { Container, ProductCard } from '@/ui';
import { getAllProducts, searchProducts } from '@/data';
import { colors } from '@/theme/colors';
import { SearchOutlined } from '@ant-design/icons';
export const Enamels = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [enamels, setEnamels] = useState(getAllProducts());
    const handleSearch = (query) => {
        setSearchQuery(query);
        if (query.trim()) {
            const results = searchProducts(query);
            setEnamels(results);
        }
        else {
            setEnamels(getAllProducts());
        }
    };
    const handleEnamelClick = (enamel) => {
        console.log('Выбрана эмаль:', enamel.name);
        // Здесь можно добавить логику для открытия детальной информации
    };
    return (_jsxs(EnamelsPage, { children: [_jsx(HeroSection, { children: _jsx(Container, { size: "large", children: _jsxs(HeroContent, { children: [_jsx(HeroTitle, { children: "\u042D\u043C\u0430\u043B\u0438 \u0438 \u043B\u0430\u043A\u043E\u043A\u0440\u0430\u0441\u043E\u0447\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B" }), _jsx(HeroDescription, { children: "\u0428\u0438\u0440\u043E\u043A\u0438\u0439 \u0430\u0441\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442 \u0432\u044B\u0441\u043E\u043A\u043E\u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u044D\u043C\u0430\u043B\u0435\u0439, \u043A\u0440\u0430\u0441\u043E\u043A, \u043B\u0430\u043A\u043E\u0432 \u0438 \u0433\u0440\u0443\u043D\u0442\u043E\u0432\u043E\u043A \u0434\u043B\u044F \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u0438 \u043D\u0430\u0440\u0443\u0436\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442 \u043E\u0442 \u0432\u0435\u0434\u0443\u0449\u0438\u0445 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0435\u0439" })] }) }) }), _jsx(SearchSection, { children: _jsx(Container, { size: "large", children: _jsxs(SearchContainer, { children: [_jsx(SearchIcon, { children: _jsx(SearchOutlined, { style: { fontSize: 20, color: colors.textSecondary } }) }), _jsx(SearchInput, { type: "text", placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E \u044D\u043C\u0430\u043B\u0438...", value: searchQuery, onChange: (e) => handleSearch(e.target.value) })] }) }) }), _jsx(ProductsSection, { children: _jsxs(Container, { size: "large", children: [_jsxs(SectionHeader, { children: [_jsx("h2", { children: "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u044D\u043C\u0430\u043B\u0435\u0439" }), _jsxs("p", { children: ["\u041D\u0430\u0439\u0434\u0435\u043D\u043E \u0442\u043E\u0432\u0430\u0440\u043E\u0432: ", enamels.length] })] }), enamels.length > 0 ? (_jsx(ProductsGrid, { children: enamels.map((enamel) => (_jsx(ProductCard, { product: enamel, onClick: handleEnamelClick }, enamel.id))) })) : (_jsxs(NoResults, { children: [_jsx(NoResultsIcon, { children: "\uD83D\uDD0D" }), _jsx(NoResultsTitle, { children: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E" }), _jsx(NoResultsText, { children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A\u043E\u0432\u044B\u0439 \u0437\u0430\u043F\u0440\u043E\u0441 \u0438\u043B\u0438 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432\u0435\u0441\u044C \u043A\u0430\u0442\u0430\u043B\u043E\u0433" })] }))] }) })] }));
};
const EnamelsPage = styled.div `
  min-height: 100vh;
`;
const HeroSection = styled.section `
  background: ${colors.gradientHero};
  padding: 80px 0 60px;
  text-align: center;
`;
const HeroContent = styled.div `
  max-width: 800px;
  margin: 0 auto;
`;
const HeroTitle = styled.h1 `
  font-size: 48px;
  font-weight: 700;
  color: ${colors.textPrimary};
  margin: 0 0 24px 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;
const HeroDescription = styled.p `
  font-size: 18px;
  color: ${colors.textSecondary};
  line-height: 1.6;
  margin: 0;
`;
const SearchSection = styled.section `
  padding: 40px 0;
  background: ${colors.backgroundPrimary};
  border-bottom: 1px solid ${colors.borderLight};
`;
const SearchContainer = styled.div `
  position: relative;
  max-width: 600px;
  margin: 0 auto;
`;
const SearchIcon = styled.div `
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
`;
const SearchInput = styled.input `
  width: 100%;
  padding: 16px 16px 16px 48px;
  border: 2px solid ${colors.borderMedium};
  border-radius: 12px;
  font-size: 16px;
  background: ${colors.backgroundPrimary};
  color: ${colors.textPrimary};
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px rgba(227, 30, 36, 0.1);
  }

  &::placeholder {
    color: ${colors.textSecondary};
  }
`;
const ProductsSection = styled.section `
  padding: 60px 0;
  background: ${colors.backgroundSecondary};
`;
const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 40px;

  h2 {
    font-size: 32px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin: 0 0 8px 0;
  }

  p {
    font-size: 16px;
    color: ${colors.textSecondary};
    margin: 0;
  }
`;
const ProductsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  align-items: stretch;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  /* Убеждаемся, что все карточки имеют одинаковую высоту */
  > * {
    height: 100%;
    min-height: 320px;
  }
`;
const NoResults = styled.div `
  text-align: center;
  padding: 80px 20px;
`;
const NoResultsIcon = styled.div `
  font-size: 64px;
  margin-bottom: 24px;
`;
const NoResultsTitle = styled.h3 `
  font-size: 24px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 16px 0;
`;
const NoResultsText = styled.p `
  font-size: 16px;
  color: ${colors.textSecondary};
  margin: 0;
  max-width: 400px;
  margin: 0 auto;
  line-height: 1.5;
`;
export default Enamels;
